import React from "react";
import { Link } from "react-router-dom";
import { Phone, Mail, MapPin } from "lucide-react";
import Logo from "./Logo";

export default function SiteFooter() {
  return (
    <footer className="mt-24 bg-[color:var(--ww-navy)] text-slate-200">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-14 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div>
          <div className="mb-4"><Logo variant="white-on-dark" size="md" /></div>
          <p className="text-sm text-slate-300 leading-relaxed">
            Oregon's trusted pressure washing experts. Sparkling clean results, rain or shine.
          </p>
        </div>
        <div>
          <h4 className="font-display uppercase tracking-widest text-white mb-3 text-lg">Services</h4>
          <ul className="space-y-2 text-sm">
            <li><Link to="/services#house-washing" className="hover:text-[color:var(--ww-light-blue)]">House Washing</Link></li>
            <li><Link to="/services#driveways-sidewalks" className="hover:text-[color:var(--ww-light-blue)]">Driveways &amp; Sidewalks</Link></li>
            <li><Link to="/services#deck-cleaning" className="hover:text-[color:var(--ww-light-blue)]">Deck &amp; Fence Cleaning</Link></li>
            <li><Link to="/services#roof-exterior" className="hover:text-[color:var(--ww-light-blue)]">Roof &amp; Exterior Cleaning</Link></li>
            <li><Link to="/services#commercial-buildings" className="hover:text-[color:var(--ww-light-blue)]">Commercial Property Washing</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="font-display uppercase tracking-widest text-white mb-3 text-lg">Company</h4>
          <ul className="space-y-2 text-sm">
            <li><Link to="/about" className="hover:text-[color:var(--ww-light-blue)]">About Us</Link></li>
            <li><Link to="/faq" className="hover:text-[color:var(--ww-light-blue)]">FAQ</Link></li>
            <li><Link to="/franchising" className="hover:text-[color:var(--ww-light-blue)]">Partner With Us</Link></li>
            <li><Link to="/quote" className="hover:text-[color:var(--ww-light-blue)]">Free Estimate</Link></li>
            <li><Link to="/book" className="hover:text-[color:var(--ww-light-blue)]">Book Online</Link></li>
            <li><Link to="/login" className="hover:text-[color:var(--ww-light-blue)]">Admin Login</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="font-display uppercase tracking-widest text-white mb-3 text-lg">Get in touch</h4>
          <ul className="space-y-3 text-sm">
            <li className="flex items-start gap-2"><Phone className="h-4 w-4 mt-0.5 text-[color:var(--ww-gold)]" /> [PHONE]</li>
            <li className="flex items-start gap-2"><Mail className="h-4 w-4 mt-0.5 text-[color:var(--ww-gold)]" /> hello@wonderwashers.com</li>
            <li className="flex items-start gap-2"><MapPin className="h-4 w-4 mt-0.5 text-[color:var(--ww-gold)]" /> Serving Eugene &amp; the Willamette Valley, Oregon</li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 md:px-12 py-6 flex flex-col md:flex-row md:items-center justify-between gap-4 text-xs text-slate-400">
          <div>&copy; {new Date().getFullYear()} Wonder Washers Pressure Washing. Locally owned &amp; operated, serving Eugene &amp; the Willamette Valley, Oregon. All rights reserved.</div>
          <div className="max-w-lg">
            <span>By providing your info you consent to SMS/email from Wonder Washers. Reply STOP to opt out. Msg &amp; data rates may apply.</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
